import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Button,
  makeStyles,
  TextField,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  Checkbox,
  Container,
  IconButton,
  CircularProgress,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AddCircleOutline, KeyboardArrowDown, KeyboardArrowUp, Visibility } from "@material-ui/icons";
import ExceptionCollapsibleRow from "./ExceptionCollabpsibleRow";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import moment from "moment";
import CreateAnEvent from './createEvent'
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import VisibilityIcon from '@material-ui/icons/Visibility';
import ViewQualityEventDrawer from './viewEvent/index'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
  },
  statusClosed: {
    color: "white",
    backgroundColor: "red",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  statusOpen: {
    color: "white",
    backgroundColor: "green",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  orangeCheckbox: {
    color: "#F26336",
    "&.Mui-checked": {
      color: "#F26336",
    },
  },
  table: {
    // width: "100%",
    marginBottom: "20px",
  },
  tableCell: {
    borderBottom: "none", // Optional: Remove default bottom borders
    padding: "8px 16px",
    fontSize: "14px", // Adjust the font size if needed
    fontWeight: "500",
  },
  tableHeadCell: {
    borderBottom: "none",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "8px 16px",
    textAlign: "left",
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  addButton: {
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: '1.5rem',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  selectSty: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingRight:'32px'
    }
  }
}));

const ExceptionDetails = (props) => {
  const { open, projectData, deliverablesData, row, workItemDetails, addException } = props;
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true)
  const [error, setError] = useState(false);
  const [exceptionTableError, setTableError] = useState(false)
  const [exceptionData, setExceptionData] = useState({});
  const [deliverableBatchDetails, setDeliverableBatchDetails] = useState(null)

  useEffect(() => {
    let url = null;
      const data2 = {
        collabrixBatchID: projectData.collabrixBatchID
      };
  
      axios
        .post(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliverableBatchDetails`, data2)
        .then((res) => {
          
          if (res.data.status) {
            setDeliverableBatchDetails(res.data.data.deliverableBatchDetails);
            setIsLoading(false);
            
            const data = {
              batchNumber: res.data.data.deliverableBatchDetails ? res.data.data.deliverableBatchDetails.batchNumber: "",
            };
            axios
              .post(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchQAExceptionDetails`,
                data
              )
              .then((res2) => {
                if (res2.data.status) {
                  setExceptionData(res2.data.data);
                  setTableLoading(false);
                } else {
                  setTableLoading(false);
                  setTableError(true);
                }
              })
              .catch((err) => {
                console.log(err);
                setTableLoading(false);
                setTableError(true);
              });
          } else {
            setIsLoading(false);
            setError("Failed to fetch deliverable batch details.");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          if (err?.response?.status === 404) {
            setError("Details not found.");
          } else {
            setError("Something went wrong. Please contact Schrocken support.");
          }
        });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleExceptionReload = () => {
    setTableLoading(true);
    const data = {
      batchNumber: deliverableBatchDetails.batchNumber ? deliverableBatchDetails.batchNumber: "",
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchQAExceptionDetails`,
        data
      )
      .then((res2) => {
        if (res2.data.status) {
          setExceptionData(res2.data.data);
          setTableLoading(false);
        } else {
          setTableLoading(false);
          setTableLoading(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);
        setTableError(true);
      });
  }

  const Row = ({ exceptionRow }) => {
    const [openException, setOpenException] = useState(false);
    const [openViewException, setViewException] = useState(false)
    const [impactOnProduct, setImpactOnProduct] = useState(exceptionRow.impactOnProduct ==='Negligible' ? 'NO':'YES')
    const [exceptionSeverity, setExceptionSeverity] = useState(String(exceptionRow.exceptionSeverity).toUpperCase())

    const dialogViewScreen = () => {
      setViewException(!openViewException)
    }

    const handleFilterChange = (type, val) => {
      if (type === 'impact') {
        setImpactOnProduct(val)
      } else {
        setExceptionSeverity(val)
      }
    }

    return (
      <>
        <TableRow>
          {!addException && <TableCell>
            <IconButton onClick={() => setOpenException(!openException)}>
              {openException ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>}
           
          <TableCell align="right" style={{whiteSpace:'nowrap'}}>{exceptionRow.collabrixExceptionID}</TableCell>
          <TableCell align="left" >{exceptionRow.exceptionDescription}</TableCell>
          <TableCell align="left" style={{whiteSpace:'nowrap'}}>
            {moment(exceptionRow.creationDate).format("DD-MMM-YYYY").toUpperCase()}
          </TableCell>
          <TableCell align="left" style={{width:'120px'}} >{exceptionRow.roleAssigned}</TableCell>
          <TableCell align="left" >{exceptionRow.userAssignedName}</TableCell>
          <TableCell align="center" >
            <Checkbox
              checked={exceptionRow.requireSponsorSMEReview}
              disabled
              classes={{ root: classes.orangeCheckbox }}
            />
          </TableCell>
          <TableCell align="center" >
            <Checkbox
              checked={exceptionRow.requireSponsorQAReview}
              disabled
              classes={{ root: classes.orangeCheckbox }}
            />
          </TableCell>
          <TableCell>
            {addException ?
              <Select
              fullWidth
              variant="outlined"
              // style={{paddingTop:'10px',paddingBottom:'10px'}}
              className={classes.selectSty}
                value={impactOnProduct}
                onChange={(e) => handleFilterChange("impact", e.target.value)}
                displayEmpty
              >
                <MenuItem value="YES">YES</MenuItem>
                <MenuItem value="NO">NO</MenuItem>
              </Select>: impactOnProduct }
            
          </TableCell>
          <TableCell>
            {addException ? 
              <Select
                fullWidth
                variant="outlined"
                // style={{paddingTop:'10px',paddingBottom:'10px'}}
                className={classes.selectSty}
            value={exceptionSeverity}
            onChange={(e) => handleFilterChange("severity", e.target.value)}
            displayEmpty
          >
            <MenuItem value="LOW">LOW</MenuItem>
            <MenuItem value="MEDIUM">MEDIUM</MenuItem>
            <MenuItem value="HIGH">HIGH</MenuItem>
              </Select>
              : exceptionSeverity
            }
            
          </TableCell>
          {!addException &&
            <TableCell>
              <Grid
                align="center" 
                className={
                  exceptionRow.exceptionStatus === "Closed"
                    ? classes.statusClosed
                    : classes.statusOpen
                }
              >
                {exceptionRow.exceptionStatus}
              </Grid>
            </TableCell>}
          {addException &&
            <TableCell><VisibilityIcon
              fontSize='small'
              className={classes.multipleLogo}
              onClick={() => dialogViewScreen(exceptionRow.collabrixExceptionID)}
            /></TableCell>
          }
        </TableRow>

        {openException  && (
            <ExceptionCollapsibleRow
              open={openException}
              projectData={projectData}
              row={row}
              exceptionRow={exceptionRow}
              deliverablesData={deliverablesData}
              workItemDetails={workItemDetails}
            />
          )}
        
        {openViewException && (
        <ViewQualityEventDrawer
          openDialog={openViewException}
          toggleDialog={dialogViewScreen}
          eventID={exceptionRow.collabrixExceptionID}
        />
      )}
      </>
    );
  };

  return (
    <TableRow>
      <TableCell colSpan={12} style={{ margin: "0px" }}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
              }}
            >
              <CircularProgress />
            </div>
          ) : error ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                width: "100%",
              }}
            >
              <Typography style={{ textAlign: "center" }}>
                Something went wrong. Please try again.
              </Typography>
            </div>
          ) : (
            <>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell}>
                      Plant ID
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      GMP Batch
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      Batch Number
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                    MBR number
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      Start Date
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      End Date (expected)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell}>
                      {presentFormatedData(deliverableBatchDetails.plantID)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {presentFormatedData(deliverableBatchDetails.gmpBatchNumber)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {presentFormatedData(deliverableBatchDetails.batchNumber)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {presentFormatedData(deliverableBatchDetails.numberBMR)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {deliverableBatchDetails?.batchStartDate ? moment(deliverableBatchDetails.batchStartDate).format(
                        "DD-MMM-YYYY"
                      ).toUpperCase():'NA'}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {deliverableBatchDetails?.batchEndDate ? moment(deliverableBatchDetails.batchEndDate).format("DD-MMM-YYYY").toUpperCase():'NA'}
                    </TableCell>
                  </TableRow>
                </TableBody>
                  </Table>
                  {addException && 
                   <Box className={classes.buttonGroup}>
                   <CreateAnEvent deliverablesData={deliverableBatchDetails} exceptionData={exceptionData} workItemDetails={row} handleExceptionReload={handleExceptionReload} />
                 </Box>
                  }
                   

              <Table style={{ border: "1px solid #ddd", marginTop: "1rem" }}>
                <TableHead>
                      <TableRow>
                        {!addException && <TableCell className={classes.tableHead}></TableCell>}
                        
                    <TableCell align="right" style={{whiteSpace:'nowrap'}} className={classes.tableHead}>
                      Exception ID
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Exception Created
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}  className={classes.tableHead}>
                      Created Date
                    </TableCell>
                    <TableCell align="left"  className={classes.tableHead}>
                      Assigned To (Role)
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Assigned To (User)
                    </TableCell>
                    <TableCell align="center"  className={classes.tableHead}>
                      Require Sponsor Review (SME)
                    </TableCell>
                    <TableCell align="center"  className={classes.tableHead}>
                      Require Sponsor Review (QA)
                    </TableCell>
                    <TableCell align="left"  className={classes.tableHead}>
                      Impact on Product
                    </TableCell>
                    <TableCell align="left"  className={classes.tableHead}>
                      Exception Severity
                    </TableCell>
                        {!addException && <TableCell align="center"  className={classes.tableHead}>Status</TableCell>}
                        {addException && <TableCell className={classes.tableHead}>Action</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableLoading === true ? (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={12}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' />
                      </div>
                    </TableCell>
                  </TableRow>)
                : exceptionTableError ? <TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={12}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow> : exceptionData?.exceptionDetailsList ? exceptionData.exceptionDetailsList.map((row, index) => (
                    <Row key={index} exceptionRow={row} />
                  )): <TableRow>
                  <TableCell
                    colSpan={12}
                    align='center'
                  >
                    No Records Found
                  </TableCell>
                  </TableRow>}
                </TableBody>
              </Table>
            </>
          )}
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default ExceptionDetails;
